import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import urlsService from "@/services/urls";

export const useUrlsStore = defineStore("urls", () => {
  const toast = useToast();
  const loading = ref(false);

  async function addUrl(payload) {
    loading.value = true;
    try {
      const res = await urlsService.addUrl(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function editUrl(payload) {
    loading.value = true;
    try {
      const res = await urlsService.editUrl(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteUrl(payload) {
    loading.value = true;
    try {
      const res = await urlsService.deleteUrl(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    addUrl,
    editUrl,
    deleteUrl,
  };
});
